import React from 'react'
import { Badge } from 'react-bootstrap';

export default function StatusChip({ bg,pill, title, className}) {
    return (
        <Badge bg={bg} pill={pill} className={`fw-medium rounded-1 custon-status-chip ${className}`}>{title}</Badge>
    )
}
